// extracted by mini-css-extract-plugin
export default {"root":"UserNotes_root__zGurW","textBox":"UserNotes_textBox__yx1Ma"};